export default __webpack_public_path__ + "static/main_video-01-cd4901d9eaed5db5fa97ba3d0445b3cf.webm";